import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";

// @material-ui/icons
import Mail from "@material-ui/icons/Mail";
import Person from "@material-ui/icons/Person";
import School from "@material-ui/icons/School";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import ReactPlayer from 'react-player'

import sectionSubscribeLineStyle from "assets/jss/material-kit-pro-react/views/blogPostsSections/sectionSubscribeLineStyle.jsx";

//firebase
import { auth } from 'assets/firebase';

var fullName;
var emailAddress;
var school;

class SubscribeLine extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      signedUp: false
    }

    this.subscribe = this.subscribe.bind(this);
  }

  componentDidMount() {

    //var user = auth.getCurrentUser();
    
    //const videoPlayer = document.createElement("script");
    //videoPlayer.innerHTML = '<script src="https://fast.wistia.com/embed/medias/8vxxxso61o.jsonp" async></script><script src="https://fast.wistia.com/assets/external/E-v1.js" async></script><div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_8vxxxso61o videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img src="https://fast.wistia.com/embed/medias/8vxxxso61o/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" onload="this.parentNode.style.opacity=1;" /></div></div></div></div>';
    //document.getElementById('divVideoPlayer').appendChild(videoPlayer);
  }

  subscribe() {
    fullName = document.getElementById('fullName').value;
    emailAddress = document.getElementById('emailAddress').value;
    school = document.getElementById('school').value;
    
    auth.createUserWithEmailAndPassword(emailAddress, 'noPassword')
    .then(result => {
      
      if (result.user) {
        // User is signed in.
        //var isAnonymous = user.isAnonymous;
        //var uid = user.uid;
    
        console.log("user.uid:");
        console.log(result.user.uid);
  
        const intercom = document.createElement("script");
        intercom.innerHTML = 'window.Intercom("boot", { app_id: "l0gl1yia", AudienceType: "principal", user_id: "' + result.user.uid + '", email: "' + emailAddress + '", name: "' + fullName + '", School:"' + school + '"});';
        document.body.appendChild(intercom);
  
        this.setState({signedUp: true})
        // ...
      } else {
        // User is signed out.
        console.log('no user returned.')
      }
    });
  }

  displaySignup() {
    if(this.state.signedUp)
      return "none";
    else
      return "block";
  }

  displayThanks() {
    if(this.state.signedUp)
      return "block";
    else
      return "none";
  }

  
  render() {
    
    const { classes } = this.props;
    return (
      <div style={{backgroundColor:"#efefef"}}>  
        <div className={classes.section}>
          <div className={classes.container}>
            <GridContainer>
              <GridItem xs={12} sm={5} >
                <Card className={classes.card1}>
                  <CardHeader
                    contact
                    color="warning"
                    className={classes.textCenter}
                  >
                    <h4 className={classes.cardTitle}>Learn More</h4>
                  </CardHeader>
                  <CardBody style={{display:this.displayThanks(), minHeight:"210px"}}>
                    <GridContainer>
                      <GridItem xs={12}>
                        <br />
                        You are signed up! Thank you so much for giving
                        us the opportunity to tell you more about All Things EQ!
                      </GridItem>
                    </GridContainer>
                  </CardBody>
                  <CardBody style={{display:this.displaySignup()}}>
                    <GridContainer>
                      <GridItem xs={12}>
                        <br />
                        Sign up to learn more about All Things E.Q., 
                        how it is being used in schools,  
                        what it can do for your students and teachers.
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                          id="fullName"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Person className={classes.icon} />
                              </InputAdornment>
                            ),
                            placeholder: "Your Full Name..."
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                          id="school"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <School className={classes.icon} />
                              </InputAdornment>
                            ),
                            placeholder: "Your School..."
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                          id="emailAddress"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Mail className={classes.icon} />
                              </InputAdornment>
                            ),
                            placeholder: "Your Email..."
                          }}
                          
                        />
                      </GridItem>
                    </GridContainer>
                  </CardBody>
                  <CardFooter className={classes.justifyContentBetween} style={{display:this.displaySignup()}}>
                    <Button color="primary" className={classes.pullRight} onClick={this.subscribe}>
                      Sign Up
                    </Button>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={7} >

                <GridContainer style={{padding:"20px", marginTop:"54px" }}>
                  
                  <ReactPlayer url='https://www.youtube.com/watch?v=ifCwcQn54vo' width='100%' />
                  <ReactPlayer url='https://www.youtube.com/watch?v=XXwuMGs-T_k' width='100%' style={{display:"none"}} />

                </GridContainer>

              </GridItem>
              <GridItem xs={12} sm={6} md={6} style={{display:"none"}}>
                <br /><br />
                Watch our parent video to see how we explain the program.
                <br />
                <div style={{backgroundColor:"black"}}>
                  <ReactPlayer url='https://allthingseq.wistia.com/medias/8vxxxso61o' width='100%' />
                </div>
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(sectionSubscribeLineStyle)(SubscribeLine);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/SubscribeLine.jsx